import Realtime from 'realtime-messaging';

const APP_KEY = 'rACnDM'
export class SubscribeStore {
    constructor(){
        this.realtime = null
        this.channel = null
        this.client  = null
        this.clientId = Math.floor(Math.random() * 10000);

        
        if (process.env.NODE_ENV == "development") {
            this.baseChannel = 'demo2.bigfix.co/korat'
        }else{
            let parts = window.location.hostname.split('.');  
            let list = window.location.pathname.split('/');          
            //let SITE_APP = parts.shift();
            let SITE_APP = window.location.hostname
            let ORG_ID = list[1]
            this.baseChannel = SITE_APP+'/'+ORG_ID;
        }        
    }


    send(jsonObj){
        
        let msg = JSON.stringify(Object.assign(jsonObj,{clientId:this.clientId}))
        this.realtime.send(this.channel,msg)
    }

    sendChannel(channel,jsonObj){
      channel = this.baseChannel+'/'+channel  
      let msg = JSON.stringify(Object.assign(jsonObj,{clientId:this.clientId}))
      this.realtime.send(channel,msg)
    }

    unsubscribe(){
        if(this.realtime!==null){
            this.client.unsubscribe(this.channel)            
        }    
        this.channel = null    
    }

    subscribeChannel(channel,subscribeFunc,onConnectedFunc){
        channel = this.baseChannel+'/'+channel
        if(this.realtime!==null){
            //Skip subscribe
            if(channel===this.channel)
              return
            
            if(this.client.isSubscribed(this.channel))
                this.client.unsubscribe(this.channel)
            this.channel = channel

            console.log("subscribe",channel);
            this.client.subscribeWithBuffer(channel, this.clientId, (client, channel,seqId, message) => {  
                console.log("Received message:",message);
                let jsonObj = JSON.parse(message)
                if(this.clientId!==jsonObj.clientId){
                  console.log("Process message:", jsonObj);
                  subscribeFunc(jsonObj)
                }
              });
        }else{
            Realtime.loadOrtcFactory(Realtime.IbtRealTimeSJType, (factory, error) => {
                if(!error) {
                  this.realtime = factory.createClient();        
                  this.realtime.onConnected = (client) => {
                    console.log("realtime connected",channel);
                    this.client  = client

                    if(onConnectedFunc!==undefined)
                      onConnectedFunc()
                    // subscribe a channel to receive messages
                    //client.subscribe(channel, true, (client, channel, message) => {
                    client.subscribeWithBuffer(channel, this.clientId,
                        (client, channel, seqId, message) => {
                      console.log("Received message:",message);
                      let jsonObj = JSON.parse(message)
                      if(this.clientId!==jsonObj.clientId){
                        console.log("Process message:", jsonObj);
                        subscribeFunc(jsonObj);
                      }
                    });
                  }
           
                  this.realtime.setClusterUrl("https://ortc-developers.realtime.co/server/ssl/2.1/");
                  //this.realtime.connect(APP_KEY, 'myToken');
                }
              }); 
        }
      
        this.channel = channel                 
    }

  connect(channel, callback) {
    if (this.realtime === null) {
      channel = this.baseChannel + '/' + channel;
      Realtime.loadOrtcFactory(Realtime.IbtRealTimeSJType, (factory, error) => {
        if (!error) {
          this.realtime = factory.createClient();

          this.realtime.onConnected = (client) => {
            console.log('realtime connected', channel);
            this.client = client;
            this.channel = channel;
            callback();
          };

          this.realtime.onDisconnected = (client) => {
            console.log('realtime disconnected');
          };

          this.realtime.setClusterUrl(
              'https://ortc-developers.realtime.co/server/ssl/2.1/');
          //this.realtime.connect(APP_KEY, 'myToken');
        }
      });
    } else {
      console.log('realtime already connected');
    }
  }

  disconnect() {
    if (this.realtime) {
      this.realtime.disconnect();
      this.realtime = null
      return true;
    } else {
      console.log('realtime has not been connected yet');
      return false;
    }
  }
}

export default new SubscribeStore()




// WEBPACK FOOTER //
// ./src/stores/SubscribeStore.js